import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { privacyRequestsApi, type PrivacyRequestListParams } from '../api/privacy-requests-api';

import { privacyRequestKeys } from './privacy-request-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function privacyRequestListQueryOptions(storeId: string, params: PrivacyRequestListParams) {
  return queryOptions({
    queryKey: privacyRequestKeys.list(storeId, params),
    queryFn: () => privacyRequestsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function usePrivacyRequests(storeId: string, params: PrivacyRequestListParams) {
  return useQuery(privacyRequestListQueryOptions(storeId, params));
}
